'use client';

import { useEffect, useSyncExternalStore } from 'react';
import { areAnalyticsCookiesAllowed } from '@/lib/analytics/consent';
import {
  GOOGLE_TAG_MANAGER_CONTAINER_ID,
  getGoogleTagManagerConsentState,
} from '@/lib/analytics/google-tag-manager';

const getServerSnapshot = () => false;
const CONSENT_CHECK_INTERVAL_MS = 1000;

function subscribe(onStoreChange: () => void): () => void {
  if (typeof window === 'undefined') return () => {};

  let previousValue = areAnalyticsCookiesAllowed();
  const emitIfChanged = () => {
    const nextValue = areAnalyticsCookiesAllowed();
    if (nextValue === previousValue) return;

    previousValue = nextValue;
    onStoreChange();
  };

  const intervalId = window.setInterval(
    emitIfChanged,
    CONSENT_CHECK_INTERVAL_MS,
  );

  window.addEventListener('focus', emitIfChanged);
  document.addEventListener('visibilitychange', emitIfChanged);

  return () => {
    window.clearInterval(intervalId);
    window.removeEventListener('focus', emitIfChanged);
    document.removeEventListener('visibilitychange', emitIfChanged);
  };
}

export function GoogleTagManagerConsentUpdater() {
  const analyticsAllowed = useSyncExternalStore(
    subscribe,
    areAnalyticsCookiesAllowed,
    getServerSnapshot,
  );

  useEffect(() => {
    if (!GOOGLE_TAG_MANAGER_CONTAINER_ID) return;
    if (typeof window.gtag !== 'function') return;

    window.gtag(
      'consent',
      'update',
      getGoogleTagManagerConsentState(analyticsAllowed),
    );
  }, [analyticsAllowed]);

  return null;
}
